import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Blocks, CalendarDays, ClipboardList, LayoutDashboard } from "lucide-react";
import { BOOKING_STATUS_LABELS } from "../config";
import "./PhoenixAdmin.css";

export function PhoenixAdminNav() {
  const location = useLocation();
  const links = [
    ["/admin/phoenix-bookings", "Bookings", LayoutDashboard],
    ["/admin/phoenix-calendar", "Calendar", CalendarDays],
    ["/admin/phoenix-spaces", "Spaces", ClipboardList],
    ["/admin/phoenix-blocked-dates", "Blocked dates", Blocks],
  ];
  return (
    <nav className="phx-admin-nav" aria-label="Phoenix Hub administration">
      {links.map(([to, label, Icon]) => (
        <Link key={to} to={to} className={location.pathname.startsWith(to) ? "active" : ""}>
          <Icon aria-hidden="true" /> {label}
        </Link>
      ))}
    </nav>
  );
}

export function AdminPageHeader({ eyebrow = "Phoenix Hub administration", title, children }) {
  return (
    <header className="phx-admin-head">
      <div><p className="phx-kicker">{eyebrow}</p><h1>{title}</h1>{children}</div>
    </header>
  );
}

export function StatusBadge({ status }) {
  return <span className={`phx-status phx-status-${status}`}>{BOOKING_STATUS_LABELS[status] || status || "Unknown"}</span>;
}

export function formatTimestamp(value, options = {}) {
  if (!value) return "—";
  const date = typeof value.toDate === "function" ? value.toDate() : new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return new Intl.DateTimeFormat("en-GB", {
    dateStyle: options.dateOnly ? "medium" : "medium",
    ...(options.dateOnly ? {} : { timeStyle: "short" }),
    timeZone: "Europe/London",
  }).format(date);
}

export function displaySpaceNames(ids = [], spaces = []) {
  return ids.map((id) => spaces.find((space) => space.id === id)?.name || (id === "unsure" ? "Unsure — please advise" : id)).join(", ");
}

